import * as storage from './storage';
import * as utils from './utils';

export interface IPrivacyPopup {
    init(): void;
}

export default class PrivacyPopup implements IPrivacyPopup {
    private _isRendered: boolean;

    constructor() {
        this._isRendered = false;
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
    }

    init(): void {
        try {
            if (storage.hasAcceptedPrivacy()) {
                return;
            }
            this.render();
        } catch (error) {
            console.error('Privacy popup failed to initialize:', error);
        }
    }

    private handleAcceptClick(): void {
        storage.setPrivacyAccepted();
        utils.removePopup();
    }

    private render(): void {
        if (this._isRendered) {
            return;
        }
        this._isRendered = true;
        if (!document.body) {
            console.error('Privacy popup cannot be rendered: document.body is not available');
            return;
        }
        const popupElement = utils.buildPopupElement(this.handleAcceptClick);

        const thumbNav = document.body.firstChild;
        if (thumbNav && thumbNav.nodeName === 'KMX-THUMB-NAV') {
            document.body.insertBefore(popupElement, thumbNav.nextSibling);
        } else {
            document.body.insertBefore(popupElement, document.body.firstChild);
        }
    }
}
